import React from 'react';
import "./productOffersPageStyles.scss";
import ButtonBack from "../../components/Buttons/buttonBack/ButtonBack";
import ProductOffersItem from "./productOffersItem/productOffersItem";
import CustomAlert from "../../components/CustomAlert/CustomAlert";
import useProductOffersItem from "./hooks/useProductOffersItem";
import DataUndefined from "../DataUndifaend/DataUndefaind";

const ProductOffersPage = () => {
    const {
        productOffers,
        dataLoaded,
        isOpenAlert,
        alertMessage,
        alertTitle,
        alertStatusCod,
        alertLoadingGif,
        updateProductOfferAnswer,
        returnColorCard,
        handleCloseAlert
    } = useProductOffersItem();

    if (!dataLoaded) {
        return <div>Загрузка...</div>;
    }

    return (
        <div className={`product_offers_page max--width--control`}>
            <CustomAlert
                title={alertTitle}
                message={alertMessage}
                statusCod={alertStatusCod}
                isOpenAlert={isOpenAlert}
                onClose={handleCloseAlert}
                classAlertLoading={alertLoadingGif}
            />

            <ButtonBack/>

            {productOffers?.length === 0 ? (
                <DataUndefined text="У вас сейчас нет товарных предложений"/>
            ) : (
                <div className={`product_offers_page_list`}>
                    {productOffers.map((item) => (
                        <ProductOffersItem
                            key={item.guid}
                            item={item}
                            onAnswerUpdate={updateProductOfferAnswer}
                            colorClass={returnColorCard(item.answer_yes, item.answer_no)}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default ProductOffersPage;